module.exports = "/packs/list-of-ta-image-4bcc092901aff8b39adcd360b5d56b86.png";